<template>
  <div class="dataCenter">
    <div :class="['tab_box',{'tab_box1':activeTabIndex==1,'tab_box2':activeTabIndex==2,'tab_box3':activeTabIndex==3}]">
      <div class="item_box">
        <div :class="['tab_item',{'active_tab_item':activeTabIndex==item.id}]" v-for="item in tabList" :key="item.id" @click="changeTab(item)">{{ item.name }}</div>
      </div>
      <div class="title">
        核心结论
      </div>
      <div class="value">{{ tabList[activeTabIndex-1].value }}</div>
    </div>
    <div class="show_data_box" v-show="activeTabIndex==1" style="margin-top: 10px;">
      <div class="tip_list">性别 <span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">女性粉丝比例高</div>
      <div class="sex_progress">
        <el-progress style="margin: 10px 0;" :percentage="37" color="#6a75f6" define-back-color="#da637c"></el-progress>
      </div>
      <div class="legend_box">
        <div class="item" style="color: #6a75f6;"><span style="background: #6a75f6;" class="circle"></span>男 37%</div>
        <div class="item" style="color: #da637c;"><span style="background: #da637c;" class="circle"></span>女 63%</div>
      </div>
      <div class="tip_list" style="margin-top: 20px;">年龄<span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">{{ '<23粉丝人数最多' }}</div>
      <div class="flowEachrts" ref="ageEchartsRef"></div>
      <div class="tip_list" style="margin-top: 20px;">城市<span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">广东粉丝人数最多</div>
      <div class="flowEachrts" ref="cityEchartsRef"></div>
      <div class="tip_list" style="margin-top: 20px;">设备<span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">使用苹果粉丝人数最多</div>
      <div class="flowEachrts" ref="equipmentEchartsRef"></div>
      <div class="tip_list" style="margin-top: 20px;">活跃度分布<span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">重度粉丝人数最多</div>
      <div class="table_header" v-for="item in audienceActivity" :key="item.name">
        <div class="name">{{ item.name }}</div>
        <div class="proportion"><el-progress :percentage="item.proportion1" color="#6a75f6"></el-progress>
        </div>
      </div>
    </div>
    <div class="show_data_box" v-show="activeTabIndex!=1" style="margin-top: 10px;">
      <div class="tip_box" style="margin-top: 10px;">全部粉丝爱看的视频</div>
      <div class="showFansLoveVideo" v-draggle-scroll-x>
        <div class="video_item" v-for="item in videoList" :key="item.name">
          <div class="img_box">
            <img :src="item.url" alt="">
          </div>
          <div class="name">{{ item.name }}</div>
          <div class="value">{{ activeTabIndex==2?'涨粉量':'流失粉丝量'}} <span :style="{color:item.value>0?'#d0574c':'#60b672','margin-left':'10px'}">{{ item.value }}</span></div>
        </div>
      </div>
      <div class="tip_list" style="margin-top: 20px;">性别 <span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">{{ activeTabIndex==2?'男性粉丝新增较多':'女性粉丝流失较多' }}</div>
      <div class="sex_progress">
        <el-progress style="margin: 10px 0;" :percentage="37" color="#6a75f6" define-back-color="#da637c"></el-progress>
      </div>
      <div class="legend_box">
        <div class="item" style="color: #6a75f6;"><span style="background: #6a75f6;" class="circle"></span>男 {{activeTabIndex==2?'64':'43'}}%</div>
        <div class="item" style="color: #da637c;"><span style="background: #da637c;" class="circle"></span>女 {{activeTabIndex==2?'36':'57'}}%</div>
      </div>
      <div class="tip_list" style="margin-top: 20px;">年龄 <span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">{{ activeTabIndex==2?'31-40岁新增粉丝人数最多':'23以下流失粉丝人数最多' }}</div>
      <div class="flowEachrts" ref="addAgeEchartsRef"></div>
      <div class="legend_box_fans">
        <div class="item" style="color: #7c7c7c;"><span style="background: #737fff;" class="circle"></span>{{activeTabIndex==2?'新增粉丝':'流失粉丝'}}</div>
        <div class="right_box">
          <div class="item_button" style="color: #7c7c7c;"><i class="el-icon-success"></i>全部粉丝</div>
          <div class="item_button" style="color: #7c7c7c;"><span style="" class="circle"></span>同类作者粉丝</div>
        </div>
      </div>
      <div class="tip_list" style="margin-top: 20px;">城市 <span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">{{ activeTabIndex==2?'广东新增粉丝人数最多':'广东流失粉丝人数最多' }}</div>
      <div class="flowEachrts" ref="addcityEchartsRef"></div>
      <div class="legend_box_fans">
        <div class="item" style="color: #7c7c7c;"><span style="background: #737fff;" class="circle"></span>{{activeTabIndex==2?'新增粉丝':'流失粉丝'}}</div>
        <div class="right_box">
          <div class="item_button" style="color: #7c7c7c;"><i class="el-icon-success"></i>全部粉丝</div>
          <div class="item_button" style="color: #7c7c7c;"><span style="" class="circle"></span>同类作者粉丝</div>
        </div>
      </div>
      <div class="tip_list" style="margin-top: 20px;">职业分布 <span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box">{{ activeTabIndex==2?'在校大学生新增粉丝人数最多,但同类作者粉丝非工作人员占比最大':'在校大学生流失粉丝人数最多,但同类作者粉丝非工作人员占比最大' }}</div>
      <div class="flowEachrts" ref="addfandomEchartsRef"></div>
      <div class="legend_box_fans">
        <div class="item" style="color: #7c7c7c;"><span style="background: #737fff;" class="circle"></span>{{activeTabIndex==2?'新增粉丝':'流失粉丝'}}</div>
        <div class="right_box">
          <div class="item_button" style="color: #7c7c7c;"><i class="el-icon-success"></i>同类作者粉丝</div>
        </div>
      </div>
      <div class="tip_list" v-show="activeTabIndex==3" style="margin-top: 20px;">关注天数分布 <span style="margin-left: 10px; color: #bebec1;"></span></div>
      <div class="tip_box" v-show="activeTabIndex==3">关注时长在1-3月的粉丝流失占比最高</div>
      <div class="flowEachrts" v-show="activeTabIndex==3" ref="attentionEchartsRef"></div>
      <div class="legend_box_fans" v-show="activeTabIndex==3">
        <div class="item" style="color: #7c7c7c;"><span style="background: #737fff;" class="circle"></span>{{activeTabIndex==2?'新增粉丝':'流失粉丝'}}</div>
      </div>
    </div>
  </div>
</template>
      
<script>
import {
  fansAge,
  fansCity,
  equipment,
  addFansAge,
  addFansCity,
  addFandom,
  drainFansAge,
  drainFansCity,
  drainFandom,
  daysOfAttention,
} from "./js/Operatingdata";
import { draggleScrollX } from "../../utils/directives.js";
export default {
  data() {
    return {
      tabList: [
        {
          id: 1,
          name: "全部粉丝",
          value: "近期<23粉丝群体占比较大",
        },
        {
          id: 2,
          name: "新增粉丝",
          value: "近期在校大学生粉丝新增较多",
        },
        {
          id: 3,
          name: "流失粉丝",
          value: "近期在校大学生粉丝流失较多",
        },
      ],
      activeTabIndex: 1,
      audienceActivity: [
        {
          name: "低活",
          proportion1: 35,
        },
        {
          name: "轻度",
          proportion1: 6,
        },
        {
          name: "中度",
          proportion1: 7,
        },
        {
          name: "重度",
          proportion1: 52,
        },
      ],
      videoList: [
        {
          url: require("../../assets/img/incomeData/a3.jpg"),
          name: "姐妹们我今天的...",
          value: 3,
        },
        {
          url: require("../../assets/img/incomeData/a1.jpg"),
          name: "谈恋爱要有拉扯...",
          value: 2,
        },
        {
          url: require("../../assets/img/incomeData/a2.jpg"),
          name: "四人连线超哥...",
          value: 1,
        },
      ],
      videoList2: [
        {
          url: require("../../assets/img/incomeData/l1.jpg"),
          name: "咱可不能乱亲...",
          value: -8,
        },
        {
          url: require("../../assets/img/incomeData/l2.jpg"),
          name: "提供情绪价值...",
          value: -6,
        },
        {
          url: require("../../assets/img/incomeData/l3.jpg"),
          name: "哈哈哈姐妹们...",
          value: -6,
        },
      ],
    };
  },
  directives: {
    draggleScrollX: draggleScrollX,
  },
  components: {},
  mounted() {
    this.getAgeEcharts();
    this.getCtiyEcharts(1);
    this.getCtiyEcharts(2);
  },

  methods: {
    changeTab(item) {
      // if (item.id != 1) return;
      this.activeTabIndex = item.id;
      if (item.id == 2) {
        this.videoList = [
          {
            url: require("../../assets/img/incomeData/a3.jpg"),
            name: "姐妹们我今天的...",
            value: 3,
          },
          {
            url: require("../../assets/img/incomeData/a1.jpg"),
            name: "谈恋爱要有拉扯...",
            value: 2,
          },
          {
            url: require("../../assets/img/incomeData/a2.jpg"),
            name: "四人连线超哥...",
            value: 1,
          },
        ];
        this.getAddAgeEcharts(addFansAge);
        this.getAddCityEcharts(addFansCity, 1);
        this.getAddCityEcharts(addFandom, 2);
      }
      if (item.id == 3) {
        this.videoList = this.videoList2;
        this.getAddAgeEcharts(drainFansAge);
        this.getAddCityEcharts(drainFansCity, 1);
        this.getAddCityEcharts(drainFandom, 2);
        this.getAttentionEcharts();
      }
    },
    getAgeEcharts() {
      let chart = this.$echarts.init(this.$refs.ageEchartsRef);
      var xData = fansAge.xData;
      var y1Data = fansAge.yData;
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        legend: {
          show: false, // 显示图例
          icon: "circle", // 设置图例图标为小圆圈
          itemWidth: 8, // 设置图例图标宽度，调小图标大小
          itemHeight: 8, // 设置图例图标高度，调小图标大小
          textStyle: {
            color: "#333", // 图例文字颜色
            fontSize: 12, // 调小图例文字字体大小
          },
          bottom: 10,
          left: 6,
        },
        grid: {
          top: 20,
          left: 40,
          right: 0,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#75767c",
            formatter: function (value) {
              return value + "%";
            },
            min: 0,
            max: 40,
            interval: 20,
          },
        },
        series: [
          {
            name: "占比",
            type: "bar",
            data: y1Data,
            yAxisIndex: 0, // 使用第一个 Y 轴
            itemStyle: {
              color: "#6a75f6", // 柱状图颜色
            },
            barWidth: 20,
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
    getCtiyEcharts(type) {
      let chart = null;
      var xData = [];
      var y1Data = [];
      if (type == 1) {
        chart = this.$echarts.init(this.$refs.cityEchartsRef);
        xData = fansCity.xData;
        y1Data = fansCity.yData;
      } else {
        chart = this.$echarts.init(this.$refs.equipmentEchartsRef);
        xData = equipment.xData;
        y1Data = equipment.yData;
      }
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        legend: {
          show: false, // 显示图例
          icon: "circle", // 设置图例图标为小圆圈
          itemWidth: 8, // 设置图例图标宽度，调小图标大小
          itemHeight: 8, // 设置图例图标高度，调小图标大小
          textStyle: {
            color: "#333", // 图例文字颜色
            fontSize: 12, // 调小图例文字字体大小
          },
          bottom: 10,
          left: 6,
        },
        grid: {
          top: 20,
          left: 40,
          right: 0,
        },
        dataZoom: {
          type: "slider",
          start: 0,
          end: type == 1 ? 20 : 40,
          // 固定手柄大小
          handleSize: 0,
          // 禁止缩放
          zoomLock: true,
          showDetail: false,
          // 背景颜色
          backgroundColor: "#ffffff",
          // 选中区域的背景颜色
          dataBackground: {
            lineStyle: {
              color: "#6a75f6",
            },
            areaStyle: {
              color: "rgba(249, 250, 254,.2) ",
            },
          },
          // 选中区域的颜色
          fillerColor: "rgba(215, 226, 250,.4)",
          // 边框颜色
          borderColor: "transparent",
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
            interval: 0,
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#75767c",
            formatter: function (value) {
              return value + "%";
            },
            min: 0,
            max: 40,
            interval: 20,
          },
        },
        series: [
          {
            name: "占比",
            type: "bar",
            data: y1Data,
            yAxisIndex: 0, // 使用第一个 Y 轴
            itemStyle: {
              color: "#6a75f6", // 柱状图颜色
            },
            barWidth: 20,
            barCategoryGap: "50%",
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
    getAddAgeEcharts(ageData) {
      let chart = this.$echarts.init(this.$refs.addAgeEchartsRef);
      var xData = ageData.xData;
      var y1Data = ageData.y1Data;
      var y2Data = ageData.y2Data;
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },

        grid: {
          top: 20,
          left: 40,
          right: 0,
          bottom: 35,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#75767c",
            formatter: function (value) {
              return value + "%";
            },
            min: 0,
            max: 20,
            interval: 10,
          },
        },
        series: [
          {
            name: this.activeTabIndex == 2 ? "新增粉丝" : "流失粉丝",
            type: "bar",
            data: y2Data,
            itemStyle: {
              color: "#6974ed",
            },
            barWidth: 15,
          },
          {
            name: "全部粉丝",
            type: "bar",
            data: y1Data,
            itemStyle: {
              color: "#6cd3d0",
            },
            barWidth: 15,
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
    getAddCityEcharts(ageData, type) {
      let chart =
        type == 1
          ? this.$echarts.init(this.$refs.addcityEchartsRef)
          : this.$echarts.init(this.$refs.addfandomEchartsRef);
      //
      var xData = ageData.xData;
      var y1Data = ageData.y1Data;
      var y2Data = ageData.y2Data;
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },

        grid: {
          top: 20,
          left: 40,
          right: 0,
          // bottom: 35,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#75767c",
            formatter: function (value) {
              return value + "%";
            },
            interval: 10, // 设置刻度标签的间隔
          },
          min: 0,
          max: 25,
        },
        dataZoom: {
          type: "slider",
          start: 0,
          end: type == 1 ? 15 : 50,
          // 固定手柄大小
          handleSize: 0,
          // 禁止缩放
          zoomLock: true,
          showDetail: false,
          // 背景颜色
          backgroundColor: "#ffffff",
          // 选中区域的背景颜色
          dataBackground: {
            lineStyle: {
              color: "#6a75f6",
            },
            areaStyle: {
              color: "rgba(249, 250, 254,.2) ",
            },
          },
          // 选中区域的颜色
          fillerColor: "rgba(215, 226, 250,.4)",
          // 边框颜色
          borderColor: "transparent",
        },
        series: [
          {
            name: this.activeTabIndex == 2 ? "新增粉丝" : "流失粉丝",
            type: "bar",
            data: y1Data,
            itemStyle: {
              color: "#6974ed",
            },
            barWidth: 15,
          },
          {
            name: "全部粉丝",
            type: "bar",
            data: y2Data,
            itemStyle: {
              color: "#6cd3d0",
            },
            barWidth: 15,
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
    getAttentionEcharts() {
      let chart = this.$echarts.init(this.$refs.attentionEchartsRef);
      var xData = daysOfAttention.xData;
      var y1Data = daysOfAttention.yData;
      let option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#ffffff", // 设置提示框背景颜色为白色
          textStyle: {
            color: "#666", // 设置提示框文字颜色为黑色，以保证在白色背景下可见
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        legend: {
          show: false, // 显示图例
          icon: "circle", // 设置图例图标为小圆圈
          itemWidth: 8, // 设置图例图标宽度，调小图标大小
          itemHeight: 8, // 设置图例图标高度，调小图标大小
          textStyle: {
            color: "#333", // 图例文字颜色
            fontSize: 12, // 调小图例文字字体大小
          },
          bottom: 10,
          left: 6,
        },
        grid: {
          top: 20,
          left: 40,
          right: 0,
          bottom: 35,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisTick: {
            show: false, // 不显示 x 轴刻度线
          },
          axisLabel: {
            color: "#b3b3b7", // x 轴字体颜色
          },
          axisLine: {
            show: true, // 不显示 x 轴轴线
            lineStyle: {
              color: "#b3b3b7",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#75767c",
            formatter: function (value) {
              return value + "%";
            },
            min: 0,
            max: 40,
            interval: 20,
          },
        },
        series: [
          {
            name: "占比",
            type: "bar",
            data: y1Data,
            yAxisIndex: 0, // 使用第一个 Y 轴
            itemStyle: {
              color: "#6a75f6", // 柱状图颜色
            },
            barWidth: 20,
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
  },
};
</script>
      
  <style scoped lang="scss">
.dataCenter {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  .tab_box {
    height: 160px;
    border: 4px;
    .item_box {
      display: flex;
      width: 100%;
      justify-content: space-evenly;
      font-size: 16px;
      cursor: pointer;

      .tab_item {
        padding: 10px;
        color: #717278;
      }
      .active_tab_item {
        color: #fff;
      }
    }
    .title {
      padding: 15px 10px;
      box-sizing: border-box;
      color: #d9eafc;
      font-size: 16px;
    }
    .value {
      padding: 0px 10px;
      font-size: 22px;
      font-weight: 600;
      color: #fff;
    }
  }
  .tab_box1 {
    background: url("../../assets/img/fansData/bc1.png");
    background-size: 100% 100%;
  }
  .tab_box2 {
    background: url("../../assets/img/fansData/bc2.png");
    background-size: 100% 100%;
  }
  .tab_box3 {
    background: url("../../assets/img/fansData/bc3.png");
    background-size: 100% 100%;
  }
  .show_data_box {
    width: 100%;
    padding: 10px 10px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    .header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 5px;
      .title {
        font-size: 16px;
        font-weight: 600;
      }
      .tip {
        font-size: 14px;
        color: #b3b3b7;
      }
    }
    .legend_box {
      display: flex;
      .item {
        margin-right: 20px;
        .circle {
          width: 8px;
          height: 8px;
          border-radius: 100%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
    .legend_box_fans {
      display: flex;
      justify-content: space-between;
      .item {
        margin-right: 20px;
        .circle {
          width: 8px;
          height: 8px;
          border-radius: 100%;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .right_box {
        display: flex;
        align-items: center;
        .item_button {
          margin-right: 5px;
          display: flex;
          align-items: center;
          .el-icon-success {
            color: #6fd5d9;
            font-size: 16px;
            margin-right: 2px;
          }
          .circle {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 1px solid #b6b6b6;
            margin-right: 2px;
          }
        }
      }
    }
    .table_header {
      display: flex;
      margin-top: 10px;
      // color: rgb(249, 250, 254);

      .name {
        width: 25%;
      }
      .compare {
        width: 75%;
        text-align: right;
        margin-right: 4px;
      }
      .proportion {
        width: 75%;
        text-align: left;
        margin-right: 4px;
      }
    }
    .audience_characteristics {
      .item_list {
        display: flex;
        padding: 10px 0;
        align-items: center;
        .img_box {
          width: 48px;
          height: 48px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .data_box {
          margin-left: 10px;
          .value {
            margin-top: 5px;
            color: #8a8a90;
          }
        }
      }
    }
    .tip_list {
      color: #7680f6;
      font-size: 14px;
      margin-top: 6px;
    }
    .tip_box {
      font-size: 16px;
      color: #8d8e93;
      margin-top: 5px;
    }
    .flowEachrts {
      width: 300px;
      height: 200px;
    }
    .sex_progress {
      ::v-deep .el-progress-bar__outer {
        height: 15px !important;
        border-radius: 0px !important;
        background-color: #da637c;
      }
      ::v-deep .el-progress-bar__inner {
        border-radius: 0px !important;
      }
      ::v-deep .el-progress__text {
        display: none;
      }
      ::v-deep .el-progress-bar {
        padding-right: 0px;
      }
    }
    .table_header {
      display: flex;
      margin-top: 10px;

      .name {
        width: 25%;
      }
      .compare {
        width: 75%;
        text-align: right;
        margin-right: 4px;
      }
      .proportion {
        width: 75%;
        text-align: left;
        margin-right: 4px;
      }
    }
    .showFansLoveVideo {
      display: flex;
      margin-top: 20px;
      .video_item {
        margin-right: 10px;
        .img_box {
          width: 120px;
          height: 180px;
          border-radius: 8px;
          // background: skyblue;
          margin-bottom: 10px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            object-fit: cover;
          }
        }
        .name {
          margin-bottom: 5px;
        }
        .value {
          color: #87888d;
          font-size: 13px;
        }
      }
    }
  }
}
.proportion {
  ::v-deep .el-progress-bar__outer {
    height: 15px !important;
    border-radius: 0px !important;
    background-color: #ebeef5;
  }
  ::v-deep .el-progress-bar__inner {
    border-radius: 0px !important;
  }
  ::v-deep .el-progress__text {
    font-size: 13px !important;
  }
}
</style>
      